import { MonthGroupedGrid } from "../../../../components/AdminList";
import type { ImportItem, ImportSort } from "../../../../api/types";
import { groupImports } from "../../../../logic/import-grouping";
import { ImportTile } from "./ImportTile";

export type ImportTileViewProps = {
  imports: ImportItem[];
  sortBy: ImportSort;
  onEdit: (item: ImportItem) => void;
  onViewTransactions: (item: ImportItem) => void;
  onViewCsv: (item: ImportItem) => void;
  onOpenDiff: (item: ImportItem) => void;
  onRerun: (item: ImportItem) => void;
  rerunningId: string | null;
  onDelete?: (item: ImportItem) => void;
  onRestore?: (item: ImportItem) => void;
  onClearFinalized?: (item: ImportItem) => void;
};

export const ImportTileView = ({
  imports,
  sortBy,
  onEdit,
  onViewTransactions,
  onViewCsv,
  onOpenDiff,
  onRerun,
  rerunningId,
  onDelete,
  onRestore,
  onClearFinalized,
}: ImportTileViewProps) => {
  const groups = groupImports(imports, sortBy).map((g) => ({
    month: g.month,
    items: g.imports,
  }));
  return (
    <MonthGroupedGrid
      groups={groups}
      getKey={(item) => item.id}
      renderItem={(item) => (
        <ImportTile
          item={item}
          onEdit={onEdit}
          onViewTransactions={onViewTransactions}
          onViewCsv={onViewCsv}
          onOpenDiff={onOpenDiff}
          onRerun={onRerun}
          isRerunning={rerunningId === item.id}
          onDelete={onDelete}
          onRestore={onRestore}
          onClearFinalized={onClearFinalized}
        />
      )}
    />
  );
};
